import { render, staticRenderFns } from "./basic-salary-history.vue?vue&type=template&id=5d217f9c"
import script from "./basic-salary-history.vue?vue&type=script&lang=js"
export * from "./basic-salary-history.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports